import { render } from "./users-asociate-roles.html?vue&type=template&id=46b12a24&scoped=true&ts=true"
import script from "./users-asociate-roles.ts?vue&type=script&lang=ts"
export * from "./users-asociate-roles.ts?vue&type=script&lang=ts"

import "./users-asociate-roles.scss?vue&type=style&index=0&id=46b12a24&scoped=true&lang=scss"

import exportComponent from "C:\\Desarrollo\\Proyectos\\Codigo\\Helpharma\\Seguridad\\seguridad-adminlte-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46b12a24"]])

export default __exports__